<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              :filterOfLots="false"
              :filterOfFarms="false"
            >
              <template slot="prev">
                <select-component
                  class="pt-3"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-2 col-xl-2`"
                  :labelSelect="`Tipo de Reporte`"
                  :isMultiple="false"
                  :dataOptions="reportType"
                  :initialSelection="dataFilter.reportType"
                  @onChange="handleChangeSelected"
                  modelName="reportType"
                />
                <select-component
                  class="pt-3"
                  :rowClass="`col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4`"
                  :labelSelect="`Finca`"
                  :isMultiple="false"
                  :dataOptions="farms"
                  :initialSelection="dataFilter.farmId"
                  @onChange="handleChangeSelected"
                  modelName="farmId"
                />
              </template>
              <template slot="after-lot" v-if="dataFilter.reportType == 2">
                <select-component
                  class="pt-3"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3`"
                  :labelSelect="`Estación`"
                  :isMultiple="false"
                  :dataOptions="stations"
                  @onChange="handleChangeSelected"
                  modelName="stationId"
                />
                <select-component
                  class="pt-3"
                  :rowClass="`col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3`"
                  :labelSelect="`Sensor`"
                  :dataOptions="sensors"
                  :initialSelection="dataFilter.sensors"
                  @onChange="handleChangeSelected"
                  modelName="sensors"
                />
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <card v-if="validateData">
        <el-container>
          <el-main>
            <div class="row">
              <div class="col-12">
                <card class="custom-shadow-card-header" v-if="chart">
                  <div class="row">
                    <chart-header-options
                      :chartData="actualChart"
                      :autoChange="false"
                    >
                      <template
                        slot="append"
                        v-if="
                          dataFilter.reportType == 2 && editBaseTempThreshold()
                        "
                      >
                        <div
                          class="col-1"
                          style="width: 25px; flex: initial !important"
                          :v-tooltip.bottom="`${$t(
                            'climate.base_temperature_upper_threshold'
                          )}`"
                          v-if="dataFilter.reportType == 2"
                        >
                          <temp-base-form
                            :minTemperature="getPropMinTempForm"
                            :maxTemperature="getPropMaxTempForm"
                            :isFahrenheit="data.fahrenheit"
                            @getDataReport="getData"
                          />
                        </div>
                      </template>
                    </chart-header-options>
                    <div
                      class="col-1"
                      style="padding-top: 9px; padding-right: 27px"
                      v-if="dataFilter.reportType == 2"
                    >
                      <info-temp />
                    </div>
                    <div class="col-12">
                      <highcharts :options="actualChart"></highcharts>
                    </div>
                  </div>
                </card>
                <card class="custom-shadow-card-header" v-if="tableData">
                  <card-header
                    :propPagination="pagination"
                    @searchedQuery="searchedQuery"
                    class="mr-3 mt-4"
                  />
                  <master-table
                    :infoTable="queriedData"
                    :columns="tableColumns"
                  />
                  <card-footer ref="cardfooter" :propPagination="pagination" />
                  <export-tables
                    :pdf="{
                      filename: `${$t('production.production_vs_climate')}.pdf`,
                      route: 'summary/productionvsclimate/pdf',
                      paramMethod: 'POST',
                      plusData: { ...exportData },
                    }"
                    :xls="{
                      filename: `${$t(
                        'production.production_vs_climate'
                      )}.xlsx`,
                      route: 'summary/productionvsclimate/excel',
                      paramMethod: 'POST',
                      plusData: { ...exportData },
                    }"
                  />
                  <br />
                </card>
              </div>
            </div>
          </el-main>
        </el-container>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import axios from 'axios';
import ChartHeaderOptions from 'src/components/Chart/ChartHeaderOptions.vue';
import configTable from './ReportTable';
import Filter from 'src/components/Filter/Filters.vue';
import i18n from 'src/i18n';
import InfoTemp from './InfoTemp.vue';
import MixinCharts from 'src/util/mixinCharts';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import TableDetails from './TableDetails.vue';
import TempBaseForm from './TempBaseForm.vue';

export default {
  components: {
    [ChartHeaderOptions.name]: ChartHeaderOptions,
    [Filter.name]: Filter,
    [InfoTemp.name]: InfoTemp,
    [TableDetails.name]: TableDetails,
    [TempBaseForm.name]: TempBaseForm,
    highcharts: Chart,
  },

  computed: {
    ...configTable().Search,
    exportData() {
      const response = {
        data: { ...this.tableData },
        type: this.dataFilter.reportType,
      };
      delete response.route;

      return response;
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    reportType() {
      return [
        { id: 1, name: 'Calibración' },
        //{ id: 2, name: 'Embolse' },
        { id: 3, name: 'Cosecha' },
        { id: 4, name: 'Cajas Elaboradas' },
      ];
    },
    validateData() {
      return this.chart || this.tableData;
    },
    getPropMinTempForm() {
      return {
        value: this.data.baseTemperature,
        label: i18n.t('climate.base_temperature'),
      };
    },
    getPropMaxTempForm() {
      return {
        value: this.data.upperThreshold,
        label: i18n.t('climate.upper_threshold'),
      };
    },
  },

  data() {
    return {
      pagination: {},
      tableColumns: [],
      valueCollapse: null,
      activeName: 'filter',
      stations: [],
      farms: [],
      sensors: [],
      dataFilter: {
        farmId: null,
        stationId: null,
        sensors: [],
        reportType: 1,
        comparate: false,
      },
      data: [],
      actualChart: {},
      chartOptions: [],
      chart: null,
      tableData: null,
    };
  },

  mixins: [MixinMasters, MixinMenu, MixinForm, MixinPermissions, MixinCharts],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
      if (data.name == 'stationId') {
        this.getSensors();
      }
    },

    handleFilter(data) {
      this.dataFilter = { ...this.dataFilter, ...data };
      this.getData();
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleView(_, row) {
      this.rowData = {
        ...row,
      };
      this.modals['read'] = true;
    },

    getPostData() {
      switch (this.dataFilter.reportType) {
        case 1:
        case 3:
        case 4:
          return {
            ...this.dataFilter,
            route: 'summary/productionvsclimate',
          };

        case 2:
          return {
            ...this.dataFilter,
            route: 'climates/accumulator',
            stations: [this.dataFilter.stationId],
            sensors: this.dataFilter.sensors,
            report: 1,
            cropId: 1,
          };

        default:
          break;
      }
    },

    getData() {
      this.showHideLoading(true);
      this.setupTable();

      let data = this.getPostData();

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }

      Axios.postMasters(data)
        .then((response) => {
          switch (this.dataFilter.reportType) {
            case 1:
            case 3:
            case 4:
              this.tableData = response.data.data.table;
              this.chart = response.data.data.chart;

              if (this.chart) {
                this.actualChart = {};
                setTimeout(() => {
                  this.actualChart = { ...this.columns(this.chart) };
                }, 0.1);
              } else {
                SweetAlert.warning(i18n.t('common_words.unavailable_data'));
              }
              break;
            case 2:
              this.tableData =
                response.data.data[this.dataFilter.stationId].table;
              this.chart =
                response.data.data[this.dataFilter.stationId].hcAirChart;

              if (this.chart) {
                this.actualChart = {};
                setTimeout(() => {
                  this.actualChart = {
                    ...this.lines(this.chart, false, 500, false),
                  };
                }, 0.1);
              } else {
                SweetAlert.warning(i18n.t('common_words.unavailable_data'));
              }
              break;

            default:
              break;
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    setupTable() {
      const { Table } = configTable();
      switch (this.dataFilter.reportType) {
        case 1:
          this.tableColumns = Table.calibrationTable;
          break;

        case 2:
          this.tableColumns = Table.heatColumnTable;
          break;

        case 3:
          this.tableColumns = Table.cuttingTable;
          break;

        case 4:
          this.tableColumns = Table.boxesTable;
          break;

        default:
          break;
      }
      this.pagination.perPage = 10;
      this.pagination.currentPage = 1;
      this.searchQuery = '';
      this.pagination = { ...Table.pagination };
    },

    getSensors() {
      this.dataFilter.sensors = [];
      axios
        .get(`/sensorsPerStation/${this.dataFilter.stationId}`)
        .then((response) => {
          this.sensors = this.concatAll(response.data);
        });
    },
  },

  created() {
    this.setupTable();
    Promise.all([
      Axios.getMasters('devices/stations'),
      Axios.getMasters('farms/farms/only'),
    ])
      .then(([stationsResponse, farmsResponse]) => {
        this.stations = stationsResponse.data.data;
        this.farms = farmsResponse.data.data;
      })
      .catch((error) => this.showMessageErrorsSwalAlert(error));
  },

  mounted() {
    this.selectedItemOnMenu('summary');
  },

  destroyed() {
    this.deselectedItemOnMenu('summary');
  },
};
</script>
